// events.js

import { normalize } from 'normalizr'
import store from '../store'

import eventSchema from './../schemas/event-schema'
import { MERGE_ENTITIES } from './entities'


// Actions
const SET = 'sportnect/events/SET'
const REPLACE = 'sportnect/events/REPLACE'
const RESET_CURSOR = 'sportnect/events/RESET_CURSOR'
const TOGGLE_BUSY = 'sportnect/events/TOGGLE_BUSY'

const initialState = {
    all: [],
    fetching: false,
    cursor: null,
    previous: null,
    invitationsSearchTerm: null,
    invitationsSort: {
        field: 'display_name',
        direction: 'asc',
    },
}

// Reducer
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case SET:
            return {
                ...state,
                all: state.all.concat(action.events.data),
                fetching: false,
                cursor: action.events.meta.cursor.next,
                previous: action.events.meta.cursor.current,
            }
        case REPLACE:
            return {
                ...state,
                all: action.events.data,
                fetching: false,
                cursor: action.events.meta.cursor.next,
                previous: action.events.meta.cursor.current,
            }
        case RESET_CURSOR:
            return {
                ...state,
                cursor: 0,
                previous: 0,
            }
        case TOGGLE_BUSY: {
            return {
                ...state,
                fetching: !state.fetching,
            }
        }
        default:
            return state
    }
}

// Action Creators
export function setEvents(events) {
    return {
        type: SET,
        events,
    }
}

export function replaceEvents(events) {
    return {
        type: REPLACE,
        events,
    }
}

export function resetCursor() {
    return { type: RESET_CURSOR }
}

export function toggleBusy() {
    return { type: TOGGLE_BUSY }
}

// Thunks
export function getEvents(replace = false, filter = null, applyFilter = false, toggleLoader = null) {
    if (applyFilter) {
        store.dispatch(resetCursor())
    }
    let {
        fetching, cursor, previous,
    } = store.getState().events

    // no more events
    if (fetching || cursor === null || filter === null) {
        return new Promise(resolve => resolve())
    }

    if (typeof toggleLoader === 'function') {
        toggleLoader(true)
    }

    cursor = getCursor(cursor, previous)

    store.dispatch(toggleBusy())

    return window.axios
        .get(
            `${
                window.APP_CONFIG.REACT_APP_API_URL
            }api/events?include=systemVisibility,organisingGroup,sports,owner,locations&userConnections=organized&limit=40${cursor}&${filter}&tz=${moment.tz.guess()}`
        )
        .then(
            ({ data }) => {
                if (typeof toggleLoader === 'function') {
                    toggleLoader(false)
                }

                if (replace) {
                    return store.dispatch(replaceEvents(data))
                }

                store.dispatch(setEvents(data))
            },
            () => {
                store.dispatch(toggleBusy())
            }
        )
}

function getCursor(cursor, previous) {
    let qs = ''
    qs += '&cursor=' + cursor
    qs += '&previous=' + previous

    return qs
}

/**
 * Fetch event by slug from API
 *
 * @param {string} slug - event slug
 * @param {string} includes - what will be includes on result?
 * @return {Promise}    - returns promise with event
 */
export const fetchEvent = (slug, includes) => (
    window.axios.get(`${window.APP_CONFIG.REACT_APP_API_URL}api/private/events/${slug}?&include=${includes}`)
        .then(({ data }) => {
            store.dispatch({
                type: MERGE_ENTITIES,
                entities: normalize(data.data, eventSchema).entities,
            })

            return new Promise(resolve => resolve(data.data))
        })
)

